import { render, staticRenderFns } from "./ScheduleResources.vue?vue&type=template&id=07f5e9c3&scoped=true"
import script from "./ScheduleResources.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleResources.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5e9c3",
  null
  
)

export default component.exports